import { useDebounceEffect, useDocumentVisibility } from 'ahooks';
import { useLocation } from 'react-router-dom';

import { CHAIN_ID } from '@/constants/chain';

import { QUERY_KEYS } from '@/constants/query';
import { useSinglePortfolio } from '@/features/portfolio/hook';

import { queryClient } from '@/global';
import { useEffect } from 'react';

function useFetchSinglePortfolio(
  chainId: CHAIN_ID | undefined,
  userAddr: string | undefined,
  instrumentAddr: string | undefined,
  expiry?: number,
) {
  useSinglePortfolio(chainId, userAddr, instrumentAddr, expiry);
  const documentVisibility = useDocumentVisibility();

  useEffect(() => {
    if (chainId && userAddr && instrumentAddr && expiry && documentVisibility === 'visible') {
      queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.PORTFOLIO.PORTFOLIO(chainId, userAddr, instrumentAddr, expiry),
      });
    }
  }, [chainId, expiry, instrumentAddr, userAddr, documentVisibility]);
}

/**
 * polling single insturment pair/account data on trade page
 * @param chainId
 * @param userAddr
 * @param instrumentAddr
 * @param expiry
 */
export function usePollingSingleInstrumentDataOnTradeOrEarn(
  chainId: CHAIN_ID | undefined,
  userAddr: string | undefined,
  instrumentAddr: string | undefined,
  expiry?: number,
): void {
  const { pathname } = useLocation();
  const documentVisibility = useDocumentVisibility();

  // const fetchSinglePortfolio = useFetchSinglePortfolio(chainId, userAddr, instrumentAddr, expiry);
  useFetchSinglePortfolio(chainId, userAddr, instrumentAddr, expiry);
  useDebounceEffect(
    () => {
      if (documentVisibility === 'visible' && (pathname.startsWith('/trade/') || pathname.startsWith('/earn/'))) {
        chainId &&
          instrumentAddr &&
          queryClient.invalidateQueries({ queryKey: QUERY_KEYS.FUTURES.INSTRUMENT(chainId, instrumentAddr) });
        chainId &&
          instrumentAddr &&
          expiry &&
          queryClient.invalidateQueries({
            queryKey: QUERY_KEYS.FUTURES.PAIR_INFO(chainId, instrumentAddr, expiry),
          });
      }
    },
    [pathname, documentVisibility, instrumentAddr, userAddr],
    { wait: 500 },
  );
}
